import { ReactElement, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { splitGamesIntoUnits } from './grid-utils';
import { isSmallerSelector } from '~/components/layout/mediaquery';
import { GridsContainer, Grid, CardContainer } from './grid.styles';

const cardsMap = {
	1: 'small',
	2: 'small',
	3: 'small',
	4: 'small',
	5: 'small',
	6: 'small',
	7: 'small',
	8: 'small',
	9: 'small'
} as const;

type JackpotGridFancyProps = {
	allowIncompleteUnits?: boolean;
};

const JackpotGridFancy = <T extends ReactElement<unknown>[]>({
	GameCards,
	allowIncompleteUnits = false
}: { GameCards: T } & JackpotGridFancyProps) => {
	const isSmaller = useSelector(isSmallerSelector);

	const itemsPerUnit = isSmaller ? 9 : 6;

	const units = useMemo(
		() => splitGamesIntoUnits(GameCards, itemsPerUnit, allowIncompleteUnits),
		[GameCards, itemsPerUnit, allowIncompleteUnits]
	);

	const cardSizes = useMemo(
		() => ({
			small: {
				width: isSmaller ? '101px' : '162px',
				height: isSmaller ? '101px' : '162px'
			}
		}),
		[isSmaller]
	);

	const gridSizes = useMemo(
		() => ({
			width: isSmaller ? '327px' : '510px',
			height: isSmaller ? '327px' : '336px'
		}),
		[isSmaller]
	);

	return (
		<GridsContainer>
			{units.map((cards, unitIndex) => (
				<Grid
					// eslint-disable-next-line react/no-array-index-key
					key={`unit-${unitIndex}`}
					width={gridSizes.width}
					height={gridSizes.height}
					extraStyles={{ gridTemplateColumns: `repeat(auto-fill, ${cardSizes.small.width})` }}
				>
					{cards.map((card, cardIndex) => (
						<CardContainer
							key={card.key}
							size={cardSizes[cardsMap[(cardIndex + 1) as keyof typeof cardsMap]]}
						>
							{card}
						</CardContainer>
					))}
				</Grid>
			))}
		</GridsContainer>
	);
};

export default JackpotGridFancy;
